import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Service } from "../service.class";
import { ENVIRONMENT } from "../../token";

@Injectable({
	providedIn: "root",
})
export class BusinessCentralService {
	public server_client_path: string = "/v2/clients";
	public server_sale_path: string = "/v2/sales";

	constructor(@Inject(ENVIRONMENT) protected environment, private service: Service) {}

	public getToolModelById(id: string): Observable<any> {
		return this.service.apiGetBCClients(this.environment.business_central_baseUrl + id + "&response_format=application/json");
	}

	public getClientId(id: string): Observable<any> {
		return this.service.apiGetBCClients(this.environment.business_central_baseUrl + id + "&response_format=application/json");
	}

	public getClientBCData(): Observable<any> {
		return this.service.apiGetWithHeaders(this.server_client_path + "/erp/data", {});
	}

	public getClientPaymentPDF(id?: string): Observable<any> {
		return this.service.apiGetWithHeaders(this.server_sale_path + "/download/bill/" + id, {});
	}

	public getClientBCTaxValue(): Observable<any> {
		return this.service.apiGetWithHeaders(this.server_client_path + "/erp/data/tax", {});
	}
}
